/* eslint-disable */

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MachineInventoryTable from "layouts/machine/MachineInventoryTable";

import machineService from "services/machineService";
import inactiveMachineTableData from "layouts/machine/inactive/data/inactiveMachineTableData";

function EliminatedMachines() {
  const navigate = useNavigate();
  const location = useLocation();

  const [rowsData, setRowsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

const load = useCallback(async () => {
  setIsLoading(true);
  try {
    const data = await machineService.getEliminatedMachinesWithDetails();
    setRowsData(data || []);
  } catch (e) {
    console.error("Error cargando máquinas eliminadas:", e);
    setRowsData([]);
  } finally {
    setIsLoading(false);
  }
}, []);

  useEffect(() => { load(); }, [load, location.key]);

  useEffect(() => {
  const onFocus = () => load();
  const onVisibility = () => {
    if (document.visibilityState === "visible") load();
  };

  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    window.removeEventListener("focus", onFocus);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}, [load]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Máquinas eliminadas
                </MDTypography>
                <Button color="inherit" onClick={() => navigate("/machine")}>
                  Volver a disponibles
                </Button>
              </MDBox>

              <MDBox pt={3}>
                <MachineInventoryTable
                  machines={rowsData}
                  makeTable={(listed) => inactiveMachineTableData({ eliminated: listed })}
                  expectedLocalType="Desechos"
                  tableName="máquinas eliminadas"
                  isLoading={isLoading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EliminatedMachines;

